import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import SeparateProtein from "../SeparateProteinPredictions/component";
import styles from "./styles.module.scss";

/**
 * Component to display the results of protein separation in three categories:
 * predicted, actual, and ideal.
 *
 * @param {Object} props - The props object for the component.
 * @param {Array} props.bands - The bands data to be passed to the SeparateProtein component.
 * @param {boolean} props.editable - Flag to indicate if the results are editable.
 */
const SeparateProteinResults = ({ bands, editable, component_strings }) => {
  const intl = useIntl();
  /**
   * Renders a result section with a header and a SeparateProtein component.
   *
   * @param {string} type - The type of result ('predictions', 'actual', or 'ideal').
   * @param {string} label - The label to display as the header.
   */
  const renderResultSection = (type, label) => (
    <div>
      <h4 style={{ fontSize: 20, fontWeight: 700, marginTop: "0px" }}>
        {label}
      </h4>
      <SeparateProtein
        component_type={type}
        bands={bands}
        editable={editable}
        intl={intl}
        component_strings={component_strings}
      />
    </div>
  );

  return (
    <div className={styles.results}>
      {renderResultSection(
        "predictions",
        intl.formatMessage({
          id: component_strings["predictions"],
          defaultMessage: component_strings["predictions"],
          description: "",
        })
      )}
      {renderResultSection(
        "actual",
        intl.formatMessage({
          id: component_strings["actual"],
          defaultMessage: component_strings["actual"],
          description: "",
        })
      )}
      {renderResultSection(
        "ideal",
        intl.formatMessage({
          id: component_strings["ideal"],
          defaultMessage: component_strings["ideal"],
          description: "",
        })
      )}
    </div>
  );
};

SeparateProteinResults.propTypes = {
  bands: PropTypes.array.isRequired,
  editable: PropTypes.bool.isRequired,
};

export default SeparateProteinResults;
